import { createState } from "@/global/store/zustand_store";
import { NotificationModal } from "@/shared/common/InfoPopup/NotificationModal";
import { Box, Stack, Typography, Grid } from "@mui/material";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import React from "react";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";
import { useAppStore } from "@/global/store";
import { selectPerkFailedCartEvents } from "@/global/store/data/purchaseSeats/cartManager";
import { CheckoutEventCard } from "../Checkout/YourTickets/CheckoutEventCard";
import { usePerksManager } from "../SelectPerks/usePerksManager";
import { useCartHelpers } from "../useCartHelpers";
import { purchaseSeatsTabUIDs } from "@/global/config/constants";
import { throttleTime } from "@/global/utils/utils";

export const useManagePerkErrorModal = createState({
  isOpen: false,
  isOpened: false,
  isFailedMandatoryPerks: false,
});
export function ManagePerkErrorModal() {
  const { sm: smDown, md: mdDown } = useCssMediaQuery("down");
  const modalState = useManagePerkErrorModal();

  // states
  const perkFailedCartEvents = useAppStore(selectPerkFailedCartEvents);

  // helpers
  const { onDeleteAllFailedPerks } = usePerksManager();
  const {
    handlers: { switchPurchaseSeatTab },
  } = useCartHelpers();

  const onConfirm = () => {
    modalState.reset();
    // delaying 100ms to avoid flash
    throttleTime(100, () => {
      onDeleteAllFailedPerks();
      switchPurchaseSeatTab(purchaseSeatsTabUIDs.checkout);
    });
  };
  const onClose = () => {
    modalState.reset();
    throttleTime(100, () => {
      switchPurchaseSeatTab(purchaseSeatsTabUIDs.findGames);
    });
  };

  const onXClick = () => {
    modalState.reset();
    throttleTime(100, () => {
      switchPurchaseSeatTab(purchaseSeatsTabUIDs.findGames);
    });
  };

  return (
    <NotificationModal
      isOpen={modalState.isOpen}
      hideTitleIcon
      onClose={() => onXClick()}
      onClickSecondaryButton={() => onClose()}
      onClickPrimaryButton={() => onConfirm()}
      title={modalState.isFailedMandatoryPerks ? "Sold Out" : "Out of stock"}
      hidePrimaryButton
      hideSecondaryButton
      renderBody={() => {
        return (
          <Box>
            <Box p={smDown ? 2 : 3} pb={12}>
              <Box>
                <Typography variant="body1">
                  {modalState.isFailedMandatoryPerks
                    ? "This selection is no longer available."
                    : "Some of the items you have selected are no longer available."}
                </Typography>
              </Box>

              <Box mt={2}>
                <Grid container spacing={2}>
                  {perkFailedCartEvents.map((cartEvent) => {
                    return (
                      <Grid item xs={12} key={cartEvent.eventCode}>
                        <CheckoutEventCard
                          cartEvent={cartEvent}
                          hideInventory={true}
                          hidePerkInformation={modalState.isFailedMandatoryPerks} // prettier-ignore
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            </Box>
          </Box>
        );
      }}
      renderFooter={() => {
        return (
          <Stack
            width={"100%"}
            py={2}
            px={2}
            direction={mdDown ? "column" : "row"}
            justifyContent={"flex-end"}
            gap={2}
          >
            <ModalActionButton
              size="medium"
              variant="secondary"
              onClick={() => onClose()}
            >
              {modalState.isFailedMandatoryPerks
                ? "Close"
                : "Back to Find Games"}
            </ModalActionButton>

            {!modalState.isFailedMandatoryPerks ? (
              <ModalActionButton
                size="medium"
                variant="primary"
                onClick={() => onConfirm()}
              >
                Proceed to Checkout
              </ModalActionButton>
            ) : null}
          </Stack>
        );
      }}
    />
  );
}
